export const logoWrapperStyle = {
  display: "flex",
  gap: 1,
  alignItems: "end",
}

export const walletButtonStyle = {
  borderRadius: "8px",
  backgroundColor: "greenPrimary",
}

export const walletTextStyle = {
  fontWeight: 600,
  fontSize: 14,
  textDecoration: "none",
  color: "darkPrimary",
}

export const buttonConnectWalletStyle = {
  padding: "0.5rem 0.75rem",
  borderRadius: 12,
  backgroundColor: "black",
  fontSize: "1rem",
  fontWeight: 600,
  color: "white",
}

export const launchAppButton = {
  background: "black",
  color: "white",
  fontWeight: 600,
  fontSize: { xs: 12, sm: 16 },
}
